<template>
  <div class="common-card" style="min-height:6.6rem">
    <div class="spaceLeft">
      <div class="detail-title-1">Bid number : {{pageData.number}}</div>
      <div class="status" :class="{'status-ing':pageData.status!=3,'status-over':isOver(pageData.overtime)}">{{statusMap["status_"+(isOver(pageData.overtime)?"3":pageData.status)]}}</div>
    </div>
    <el-row>
      <el-col :xs="24" :sm="24" :md="11" :lg="11">
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Starting time:</span>
          <span>{{moment(pageData.timestamp).utc().format("YYYY-MM-DD HH:mm:ss")}}</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Closing time:</span>
          <span>{{moment(pageData.overtime).utc().format("YYYY-MM-DD HH:mm:ss")}}</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Auction:</span>
          <big-number :number="pageData.amount"/>
          <span class="unit">UNIT</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Reserve price:</span>
          <big-number :number="pageData.startAmount"/>
          <span class="unit">TCash</span>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="13" :lg="13">
        <place-bid-time :hasBid.sync="hasBid" :closeTime.sync="pageData.overtime"/>
      </el-col>
    </el-row>
    <div>
      <div class="spaceLeft detail-title-2">
        All Bids
        <el-button
          @click="toDetail"
          class="upper"
          type="text"
          style="margin-left:0.2rem;"
          >more<i
            class="el-icon-d-arrow-right"
            style="margin-left:0.08rem;"
        /></el-button>
      </div>
      <el-table class="common-table" :data="tableList" v-loading="loading">
        <el-table-column prop="data1" label="" width="50px">
         <template slot-scope="{ $index }">
            {{ queryParams.total - ((queryParams.page - 1) * queryParams.pageSize + $index) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="account"
          label="Bidder"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <account :value="row.account"/>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" label="Time">
          <template slot-scope="{ row }">
            {{ moment(row.timestamp).utc().format("YYYY-MM-DD HH:mm:ss")  }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="Bid price" align="right" sortable>
          <template slot-scope="{ row }">
            <big-number :number="row.amount"/>
            <span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { auctionDetailList } from "@/api/auction.js"
import placeBidTime from "./placeBidTime.vue"
export default {
  components: { placeBidTime },
  props:{
    tableMyList:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      pageData:{},
      loading:false,
      queryParams:{
        total:0,
        page:1,
        pageSize:5
      },
      tableList: [],
      statusMap:this.$store.getters.auctionStatusMap
    };
  },
  computed: {
    hasBid(){
      return this.tableMyList.length > 0;
    }
  },
  methods: {
    toDetail(){
      this.queryParams.pageSize = 100;
      this.getBidList();
    },
    init(){
      this.pageData = {
        ...this.$route.query
      }
      this.getBidList();
    },
    getBidList(){
      this.loading = true;
      auctionDetailList({
        number:this.$route.query.number,
        pageSize:this.queryParams.pageSize,
        page:1,
      }).then(res => {
        this.tableList = res.data ? res.data.data : [];
        this.queryParams.total = res.data.total || 0;
        this.loading = false;
      }).catch(e => {
        this.loading = false;
        console.log(e)
      })
    },
    isOver(overtime){
      return new Date(overtime).getTime() <= new Date().getTime();
    },

  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped lang="scss">

.detail-title-1 {
  margin-bottom: 0.16rem;
  color: #fff;
}
.detail-title-2 {
  color: #fff;
  font-size: .26rem;
  font-weight: bold;

  margin-top: 0.4rem;
  .el-button--text{
    color: #225BFC!important;
  }
}
.unit {
  font-size: 0.16rem;
  font-weight: 500;
  color: rgba(255, 255, 255, .5);
  margin-left: 0.04rem;
}
.status{
  font-size: 0.18rem;
  font-weight: 400;
  color: #FFFFFF;
  padding:0.08rem 0.16rem 0.08rem 0.1rem;
  margin:0 0 0.16rem 0.3rem;

  &.status-ing{
    background:url("../../../../../assets/image/placeBid/ing.png")no-repeat;
    background-size:100% 100%;

  }
  &.status-over{
    background:url("../../../../../assets/image/placeBid/over.png")no-repeat;
    background-size:100% 100%;
  }
}

.detail-item {
  color: #fff;
  font-size: 0.2rem;
  font-weight: 500;

  .detail-item-label {
    color: rgba(255, 255, 255, .7);
  }
}

.common-table {
  >>> .el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>> .el-loading-spinner .path {
    stroke: #2675f1;
  }
}

// .common-table {
//   ::v-deep  &.el-table {
//     font-size: 0.16rem;
//     background: #f5f5f5;

//     .el-table__header-wrapper th {
//       background: #f5f5f5;
//       color: #aaaaaa;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//     }
//     th.is-leaf {
//       border-bottom: none;
//     }
//     td {
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1f1f1f;
//       line-height: 0.24rem;
//       background: #f5f5f5;
//       border-bottom: none;
//     }
//     &::before {
//       background: none;
//     }
//   }
//   .td-word-sm {
//     font-size: 0.16rem;
//     font-weight: 400;
//     color: #929dad;
//     line-height: 0.19rem;
//   }
// }
</style>
